import { useState, useEffect } from 'react';
import { api } from '../apiConfig';
import { useAuth } from '../contexts/AuthContext';

export const useUserRole = () => {
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchUserRole = async () => {
      if (!currentUser) {
        setUserRole(null);
        setLoading(false);
        return;
      }

      try {
        // Get user profile from backend which includes the role
        const response = await api.get('/users/profile');
        setUserRole(response.data.role);
      } catch (error) {
        console.error('Error fetching user role:', error);
        setUserRole(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUserRole();
  }, [currentUser]);

  // Role-based feature access helpers
  const hasShippingAccess = () => {
    return ['artist', 'gallery', 'curator', 'admin'].includes(userRole);
  };

  const hasArtworkManagement = () => {
    return ['artist', 'gallery', 'curator', 'admin'].includes(userRole);
  };

  const hasAdminAccess = () => {
    return userRole === 'admin';
  };

  const isCollector = () => {
    return userRole === 'collector';
  };

  const needsBusinessProfile = () => {
    return ['artist', 'gallery', 'curator', 'admin'].includes(userRole);
  };

  const needsPersonalProfile = () => {
    return userRole === 'collector';
  };

  return {
    userRole,
    loading,
    hasShippingAccess,
    hasArtworkManagement,
    hasAdminAccess,
    isCollector,
    needsBusinessProfile,
    needsPersonalProfile
  };
};